import Global from "../Common/Global";

const IndexedDb = {
  DropIndexDB: async () => {
    return new Promise((resolve, reject) => {
      if (!window.indexedDB) {
        // window.alert("Browser doesn't support IndexedDB.");
        reject(false);
      } else {
        let request = window.indexedDB.open(Global.base.indexedDb.name);
        request.onerror = (e) => {
          console.log("open failed.");
        };
        request.onsuccess = function (event) {
          let db = event.target.result;
          if (Number(process.env.REACT_APP_INDEXEDDB_VERSION) === db.version) {
            resolve(true);
          } else {
            window.indexedDB.deleteDatabase(Global.base.indexedDb.name);
            resolve("delete");
          }
        };
      }
    });
  },
  CreateIndexedDB: async () => {
    if (!window.indexedDB) {
      // window.alert("Browser doesn't support IndexedDB.");
    } else {
      let db;
      let request = window.indexedDB.open(Global.base.indexedDb.name, process.env.REACT_APP_INDEXEDDB_VERSION);
      request.onupgradeneeded = (e) => {
        db = request.result;
        db.createObjectStore("UserInfo", { keyPath: "token" });
        db.createObjectStore("TranslationCache", { keyPath: "cacheKey" });
      };
      request.onerror = (e) => {
        console.log("Onupgradeneeded failed.");
      };
      request.onsuccess = (e) => {
        db = request.result;

        db.onversionchange = (e) => {
          console.log("version changed: ", e);
        };
      };
    }
  },
  CreateTable: async (_tableName = "", _keys = []) => {
    new Promise((resolve, reject) => {
      if (!window.indexedDB) {
        // window.alert("Browser doesn't support IndexedDB.");
      } else {
        let db;
        let request = window.indexedDB.open(Global.base.indexedDb.name, process.env.REACT_APP_INDEXEDDB_VERSION);
        request.onerror = (e) => {
          console.log("Onupgradeneeded failed.");
          reject(false);
        };
        request.onsuccess = (e) => {
          db = request.result;
          resolve(request.result.version);
        };
      }
    }).then((result) => {
      let db;
      let request = window.indexedDB.open(Global.base.indexedDb.name, process.env.REACT_APP_INDEXEDDB_VERSION + 1);
      request.onupgradeneeded = (e) => {
        db = request.result;
        db.createObjectStore(_tableName, { keyPath: _keys });
      };
      request.onerror = (e) => {
        console.log("Onupgradeneeded failed.");
      };
      request.onsuccess = (e) => {
        db = request.result;
      };
    });
  },
  AddItem: async (_table = "", _data = []) => {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open(Global.base.indexedDb.name, process.env.REACT_APP_INDEXEDDB_VERSION);
      request.onerror = (e) => {
        reject(new Error("Request error : " + e.target.errorCode));
      };
      request.onsuccess = (e) => {
        const db = request.result;
        const transaction = db.transaction(_table, "readwrite");
        transaction.onerror = (e) => {
          reject(new Error("Transaction failed."));
        };
        transaction.oncomplete = (e) => {};
        const store = transaction.objectStore(_table);
        for (const data of _data) {
          const result = store.add(data);
          result.onerror = (e) => reject(new Error("Add failed."));
          result.onsuccess = (e) => resolve(true);
        }
      };
    });
  },
  GetItem: async (_table = "", _key) => {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open(Global.base.indexedDb.name, process.env.REACT_APP_INDEXEDDB_VERSION);
      request.onerror = (e) => {
        reject(new Error("Request error : " + e.target.errorCode));
      };
      request.onsuccess = (e) => {
        const db = request.result;
        const transaction = db.transaction(_table, "readonly");
        transaction.onerror = (e) => {
          reject(new Error("Transaction failed."));
        };
        transaction.oncomplete = (e) => {};
        const store = transaction.objectStore(_table);
        const storeRequest = store.get(_key);
        storeRequest.onerror = (e) => {
          reject(new Error("Get failed."));
        };
        storeRequest.onsuccess = (e) => {
          resolve(storeRequest.result);
        };
      };
    });
  },
  GetAllItem: async (_table = "") => {
    return new Promise((resolve, reject) => {
      let returnData = [];
      const request = window.indexedDB.open(Global.base.indexedDb.name, process.env.REACT_APP_INDEXEDDB_VERSION);
      request.onerror = (e) => {
        reject(new Error("Request error : " + e.target.errorCode));
      };
      request.onsuccess = (e) => {
        const db = request.result;
        const transaction = db.transaction(_table, "readonly");
        transaction.onerror = (e) => {
          reject(new Error("Transaction failed."));
        };
        transaction.oncomplete = (e) => {
          resolve(returnData);
        };
        const store = transaction.objectStore(_table);
        const storeCursor = store.openCursor();
        storeCursor.onsuccess = (e) => {
          let cursor = e.target.result;
          if (cursor) {
            const value = store.get(cursor.key);
            value.onerror = (e) => reject(new Error("Cursor failed."));
            value.onsuccess = (e) => {
              returnData.push(e.target.result);
            };
            cursor.continue();
          }
        };
      };
    });
  },
  UpdateTable: async (_table = "", _key, _data) => {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open(Global.base.indexedDb.name, process.env.REACT_APP_INDEXEDDB_VERSION);
      request.onerror = (e) => {
        reject(new Error("Request error : " + e.target.errorCode));
      };
      request.onsuccess = (e) => {
        const db = request.result;
        const transaction = db.transaction(_table, "readwrite");
        transaction.onerror = (e) => {
          reject(new Error("Transaction failed."));
        };
        transaction.oncomplete = (e) => {};
        const store = transaction.objectStore(_table);
        const storeRequest = store.get(_key);
        storeRequest.onsuccess = (e) => {
          const updateRequest = store.put(_data);
          updateRequest.onerror = (e) => reject(new Error("Update failed."));
          updateRequest.onsuccess = (e) => resolve(true);
        };
      };
    });
  },
  DeleteItem: async (_table = "", _key) => {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open(Global.base.indexedDb.name, process.env.REACT_APP_INDEXEDDB_VERSION);
      request.onerror = (e) => {
        reject(new Error("Request error : " + e.target.errorCode));
      };
      request.onsuccess = (e) => {
        const db = request.result;
        const transaction = db.transaction(_table, "readwrite");
        transaction.onerror = (e) => {
          reject(new Error("Transaction failed."));
        };
        transaction.oncomplete = (e) => {};
        const store = transaction.objectStore(_table);
        const storeRequest = store.delete(_key);
        storeRequest.onerror = (e) => reject(new Error("Delete failed."));
        storeRequest.onsuccess = (e) => resolve(true);
      };
    });
  },
  ClearTable: async (_table = "") => {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open(Global.base.indexedDb.name, process.env.REACT_APP_INDEXEDDB_VERSION);
      request.onerror = (e) => {
        reject(new Error("Request error : " + e.target.errorCode));
      };
      request.onsuccess = (e) => {
        const db = request.result;
        const transaction = db.transaction(_table, "readwrite");
        transaction.onerror = (e) => {
          reject(new Error("Transaction failed."));
        };
        transaction.oncomplete = (e) => {};
        const store = transaction.objectStore(_table);
        const storeRequest = store.clear();
        storeRequest.onerror = (e) => reject(new Error("Clear failed."));
        storeRequest.onsuccess = (e) => resolve(true);
      };
    });
  },
  GetUserInfo: async () => {
    return new Promise((resolve, reject) => {
      let returnData = [];
      const request = window.indexedDB.open(Global.base.indexedDb.name, process.env.REACT_APP_INDEXEDDB_VERSION);

      request.onerror = (e) => {
        reject(new Error("Request error : " + e.target.errorCode));
      };
      request.onsuccess = (e) => {
        const db = request.result;
        const transaction = db.transaction("UserInfo", "readonly");

        transaction.onerror = (e) => {
          reject(new Error("Transaction failed."));
        };
        transaction.oncomplete = (e) => {
          let thisData;

          if (returnData.length > 1) {
            thisData = returnData
              .sort((a, b) => {
                return new Date(a.connTime) - new Date(b.connTime);
              })
              .reverse();
            resolve(thisData[0]);
          } else if (returnData.length < 1) {
            resolve(false);
          } else {
            resolve(returnData[0]);
          }
        };

        const store = transaction.objectStore("UserInfo");
        const storeCursor = store.openCursor();
        storeCursor.onsuccess = (e) => {
          let cursor = e.target.result;

          if (cursor) {
            const value = store.get(cursor.key);
            value.onerror = (e) => reject(new Error("Cursor failed."));
            value.onsuccess = (e) => {
              // console.log("Cursor complete.");
              returnData.push(e.target.result);
            };
            cursor.continue();
          }
        };
      };
    });
  },
  
  // 사용자 정보 업데이트 함수 추가
  UpdateUserInfo: async (updateData) => {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open(Global.base.indexedDb.name, process.env.REACT_APP_INDEXEDDB_VERSION);
      
      request.onerror = (e) => {
        reject(new Error("Request error : " + e.target.errorCode));
      };
      
      request.onsuccess = (e) => {
        const db = request.result;
        const transaction = db.transaction("UserInfo", "readwrite");
        
        transaction.onerror = (e) => {
          reject(new Error("Transaction failed."));
        };
        
        transaction.oncomplete = (e) => {
          resolve(true);
        };
        
        const store = transaction.objectStore("UserInfo");
        const storeCursor = store.openCursor();
        
        storeCursor.onsuccess = (e) => {
          let cursor = e.target.result;
          
          if (cursor) {
            const userData = cursor.value;
            const updatedUserData = { ...userData, ...updateData };
            
            const updateRequest = store.put(updatedUserData);
            updateRequest.onerror = (e) => reject(new Error("Update failed."));
            updateRequest.onsuccess = (e) => {
              cursor.continue();
            };
          }
        };
      };
    });
  },
};

export default IndexedDb;
